module.exports = {
  pageTransitionTimeout: 600
}
